/* ==========================================================================
   RUQ Ceramics — Katman yöneticisi
   Çekmeceler, arama paneli ve perde arasındaki koordinasyonu tek yerden kurar.
   ========================================================================== */

(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  var scrim = document.querySelector('[data-scrim]');
  var openPanel = null;
  var lastTrigger = null;
  var scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.insetInlineStart = '0';
    document.body.style.insetInlineEnd = '0';
    document.body.style.top = -scrollY + 'px';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.insetInlineStart = '';
    document.body.style.insetInlineEnd = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  function showScrim() {
    if (!scrim) return;
    scrim.hidden = false;
    window.requestAnimationFrame(function () {
      scrim.classList.add('is-open');
    });
  }

  function hideScrim() {
    if (!scrim) return;
    scrim.classList.remove('is-open');
    window.setTimeout(function () {
      scrim.hidden = true;
    }, 300);
  }

  function openDrawer(panel, trigger) {
    if (!panel || panel === openPanel) return;
    closeAll({ silent: true });

    openPanel = panel;
    lastTrigger = trigger || null;

    panel.hidden = false;
    window.requestAnimationFrame(function () {
      panel.classList.add('is-open');
    });

    showScrim();
    lockScroll();

    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    var first = panel.querySelector(FOCUSABLE);
    if (first) window.setTimeout(function () { first.focus(); }, 120);
  }

  function closeAll(options) {
    var silent = options && options.silent;

    document.querySelectorAll('.drawer.is-open').forEach(function (panel) {
      panel.classList.remove('is-open');
      window.setTimeout(function () {
        if (!panel.classList.contains('is-open')) panel.hidden = true;
      }, 420);
    });

    document.querySelectorAll('[aria-expanded="true"]').forEach(function (trigger) {
      if (trigger.hasAttribute('data-nav-details')) return;
      trigger.setAttribute('aria-expanded', 'false');
    });

    document.dispatchEvent(new CustomEvent('ruq:overlay:close'));

    var header = document.querySelector('.header');
    if (header) header.classList.remove('is-search-open');

    if (openPanel || !silent) {
      hideScrim();
      unlockScroll();
    }

    if (!silent && lastTrigger) lastTrigger.focus();

    openPanel = null;
    if (!silent) lastTrigger = null;
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || !openPanel) return;

    var focusable = Array.prototype.filter.call(
      openPanel.querySelectorAll(FOCUSABLE),
      function (element) { return element.offsetParent !== null; }
    );
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var drawerTrigger = event.target.closest('[data-drawer-open]');
    if (drawerTrigger) {
      event.preventDefault();
      openDrawer(document.getElementById(drawerTrigger.getAttribute('aria-controls')), drawerTrigger);
      return;
    }

    var cartTrigger = event.target.closest('[data-cart-open]');
    if (cartTrigger) {
      event.preventDefault();
      openDrawer(document.getElementById('CartDrawer'), cartTrigger);
      return;
    }

    var searchTrigger = event.target.closest('[data-search-open]');
    if (searchTrigger) {
      event.preventDefault();
      closeAll({ silent: true });
      searchTrigger.setAttribute('aria-expanded', 'true');
      lastTrigger = searchTrigger;
      showScrim();

      var header = document.querySelector('.header');
      if (header) header.classList.add('is-search-open');

      document.dispatchEvent(new CustomEvent('ruq:search:open'));
      return;
    }

    if (event.target.closest('[data-drawer-close]') || event.target.closest('[data-scrim]')) {
      event.preventDefault();
      closeAll();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
    trapFocus(event);
  });

  document.addEventListener('ruq:cart:updated', function (event) {
    var data = event.detail || {};
    var markup = data.sections && data.sections['cart-drawer'];

    if (markup) {
      var parsed = new DOMParser().parseFromString(markup, 'text/html');
      var fresh = parsed.querySelector('cart-drawer');
      var current = document.getElementById('CartDrawer');

      if (fresh && current) {
        var wasOpen = current.classList.contains('is-open');
        current.replaceWith(fresh);
        fresh.hidden = !wasOpen;
        if (wasOpen) {
          fresh.classList.add('is-open');
          openPanel = fresh;
        }
      }
    }

    if (typeof data.item_count === 'number') {
      document.querySelectorAll('[data-cart-count]').forEach(function (node) {
        node.textContent = data.item_count;
        node.classList.toggle('is-empty', data.item_count === 0);
      });
    }
  });
})();
